
import React, { useState } from 'react';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="App">
      {/* Navigation Header */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-brand">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <img src="logo.svg" alt="L'Ampoma Logo" style={{ width: '30px', height: '30px' }} />
              <h1 style={{ margin: 0 }}>L'Ampoma</h1>
            </div>
            <span className="nav-tagline">Azienda Agricola di Montagna</span>
          </div>

          {/* Desktop Navigation */}
          <div className="nav-links desktop-nav">
            <a href="#home">Home</a>
            <a href="#chi-siamo">Chi Siamo</a>
            <a href="#la-terra">La Terra</a>
            <a href="#le-piante">Le Piante</a>
            <a href="#comunita">Comunità</a>
            <a href="#dove-siamo">Dove Siamo</a>
            <a href="#contatti">Contatti</a>
          </div>

          {/* Mobile Hamburger Button */}
          <button 
            className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        <div className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
          <a href="#home" onClick={closeMobileMenu}>Home</a>
          <a href="#chi-siamo" onClick={closeMobileMenu}>Chi Siamo</a>
          <a href="#la-terra" onClick={closeMobileMenu}>La Terra</a>
          <a href="#le-piante" onClick={closeMobileMenu}>Le Piante</a>
          <a href="#comunita" onClick={closeMobileMenu}>Comunità</a>
          <a href="#dove-siamo" onClick={closeMobileMenu}>Dove Siamo</a>
          <a href="#contatti" onClick={closeMobileMenu}>Contatti</a>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero-section">
        <div className="hero-overlay">
          <div className="hero-content">
            <h1 className="hero-main-title">Piante Officinali e Tintorie</h1>
            <div className="hero-features">
              <div className="feature-check"><FontAwesomeIcon icon={faCheck} style={{ color: '#4CAF50', marginRight: '8px' }} /> Agricoltura Naturale</div>
              <div className="feature-check"><FontAwesomeIcon icon={faCheck} style={{ color: '#4CAF50', marginRight: '8px' }} /> Immersa nel cuore del Parco dell'Adamello</div>
              <div className="feature-check"><FontAwesomeIcon icon={faCheck} style={{ color: '#4CAF50', marginRight: '8px' }} /> Raccolta a mano rispettando i ritmi della Natura
              </div>
            </div>
            <p className="hero-description">
              <strong>BENVENUTƏ</strong>
            </p>
            <h2 className="hero-subtitle"></h2>
            <p className="hero-text-desc">
              L'Ampoma vi porta una selezione di piante officinali coltivate a oltre 1400m s.l.m.
            </p>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="categories-section">
        <div className="container">
          <h2>Le Nostre Specialità</h2>
          <div className="categories-grid">
            <div className="category-card">
              <h3>🌿 Piante Officinali</h3>
              <p>Erbe medicinali coltivate in montagna</p>
            </div>
            <div className="category-card">
              <h3>🎨 Piante Tintorie</h3>
              <p>Per l'arte della tintura naturale</p>
            </div>
            <div className="category-card">
              <h3>📚 Laboratori</h3>
              <p>Corsi e visite guidate</p>
            </div>
            <div className="category-card">
              <h3>🌱 Tradizione</h3>
              <p>Saperi antichi della montagna</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section
      <section className="why-choose-section">
        <div className="container">
          <h2>Perché Scegliere L'Ampoma</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">🏔️</div>
              <h3>Altitudine Speciale</h3>
              <p>Oltre 1400m s.l.m. nell'Adamello per principi attivi concentrati</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🌿</div>
              <h3>Metodi Naturali</h3>
              <p>Niente chimica, dalla semina alla raccolta a mano</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🎯</div>
              <h3>Sapere Autentico</h3>
              <p>Tradizioni di montagna tramandate con rispetto</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">👥</div>
              <h3>Comunità Locale</h3>
              <p>Supportiamo artigiani e piccoli produttori</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Main Content Sections */}
      <main className="main-content">
        {/* About Section */}
        <section id="chi-siamo" className="content-section about-section">
          <div className="container">
            <div className="content-row">
              <div className="content-text">
                <h2>Chi Siamo</h2>
                <p>L'Ampoma è un'azienda agricola di montagna a Saviore dell'Adamello, nelle Alpi bresciane. Ampoma è la parola del dialetto locale per il lampone selvatico — una pianta che cresce spontanea in quota, nei margini, con tempi che non si possono forzare.</p>
                <p>Un nome che dice già molto su come si lavora qui.</p>
              </div>
              <div className="content-highlight">
                <h3>"Ampoma"</h3>
                <p>Una parola del dialetto di Saviore, quasi dimenticata. È stata scelta perché i nomi antichi custodiscono una memoria che vale la pena tenere viva.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Earth Section */}
        <section id="la-terra" className="content-section earth-section">
          <div className="container">
            <div className="content-row">
              <div className="content-text">
                <h2>La Terra</h2>
                <p>L'azienda si trova in località Maé, a oltre 1400 metri sul livello del mare, in un territorio plasmato dall'Adamello e dai suoi ghiacciai. L'aria, il suolo antico e l'escursione termica tra giorno e notte fanno sì che le piante che crescono qui abbiano profumi più intensi e principi attivi più concentrati. Non è un vanto: è semplicemente quello che succede quando si lascia fare alla montagna il suo lavoro.</p>
                <p>L'approccio è quello di non intralciarla. Niente chimica, niente forzature. Dalla semina alla raccolta a mano, si lavora in modo naturale e con rispetto per il posto in cui ci si trova.</p>
              </div>
              <div className="content-image" style={{ maxWidth: '300px', flexShrink: 0 }}>
                <img src="img1.jpg" alt="La terra dell'Adamello" className="section-image" style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
              </div>
            </div>
          </div>
        </section>

        {/* Plants Section */}
        <section id="le-piante" className="content-section plants-section">
          <div className="container">
            <div className="content-row">
              <div className="content-text">
                <h2>Le Piante</h2>
                <p>Si coltivano <strong>piante officinali e tintorie</strong> — erbe con una storia lunga, legate alla cura del corpo e all'arte del colore sui tessuti. Piante che per secoli hanno fatto parte della vita di montagna.</p>
                <p>Le produzioni sono destinate a erboristi, artigiani del tessuto naturale, piccoli produttori e laboratori. E a chiunque voglia sapere da dove vengono le cose che usa.</p>
              </div>
              <div className="content-image" style={{ maxWidth: '300px', flexShrink: 0 }}>
                <div className="feature-list">
                  <div className="feature">✓ Coltivazione con metodo naturale</div>
                  <div className="feature">✓ Raccolta a mano</div>
                  <div className="feature">✓ Essiccazione tradizionale</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Community Section */}
        <section id="comunita" className="content-section community-section">
          <div className="container">
            <div className="content-row">
              <div className="content-text">
                <h2>La Comunità</h2>
                <p>L'Ampoma non è solo un luogo dove le piante crescono. È anche un posto dove le persone si incontrano e imparano qualcosa di utile.</p>
                <p>Si organizzano visite e laboratori in campo, corsi sulle piante officinali, corsi di tintura naturale e attività legate allo stare all’aperto in montagna. Esperienze pratiche, con le mani nella terra — pensate per chi vuole rallentare e portare a casa una conoscenza vera.</p>
                <p>Intorno a L'Ampoma sta crescendo una comunità di persone curiose e appassionate. Il sapere botanico, come i semi, ha bisogno di circolare per restare vivo.</p>
              </div>
              <div className="activities-list">
                <div className="activity">
                  <h4>🌱 Visite in Campo</h4>
                  <p>Scopri la coltivazione delle piante officinali</p>
                </div>
                <div className="activity">
                  <h4>🎨 Corsi di Tintura</h4>
                  <p>L'arte antica della tintura naturale</p>
                </div>
                <div className="activity">
                  <h4>📚 Laboratori</h4>
                  <p>Esperienze pratiche con le mani nella terra</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Location Section */}
        <section id="dove-siamo" className="content-section location-section">
          <div className="container">
            <div className="content-row">
              <div className="content-text">
                <h2>Dove Siamo</h2>
                <p>L'Ampoma si trova in località Maé, nel comune di Saviore dell'Adamello, in Valle Camonica. Un luogo raggiungibile percorrendo strade di montagna che attraversano paesaggi unici nel cuore del Parco dell'Adamello.</p>
                <div className="location-details">
                  <p><strong>📍 Indirizzo:</strong> Località Maé, 25040 Saviore dell'Adamello (BS)</p>
                </div>
              </div>
              <div className="map-container">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2766.9360759920937!2d10.420565076851942!3d46.09225159131477!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4783b5000455ce9d%3A0xed3c7b863f17ab64!2sAzienda%20Agricola%20L%E2%80%99Ampoma!5e0!3m2!1sit!2sit!4v1774200073548!5m2!1sit!2sit"
                    width="100%" 
                    height="400"
                    style={{ border: 0, borderRadius: '8px', maxWidth: '100%' }}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Mappa L'Ampoma - Località Maé, Saviore dell'Adamello"
                ></iframe>
                <div className="map-link">
                  <a
                      href="https://maps.app.goo.gl/2MMFhbQr9geymrL19"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="view-map-button"
                  >
                    📍 Apri in Google Maps
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Newsletter Section */}
      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-content">
            <h2>PIANTE OFFICINALI E TINTORIE</h2>
            <p>Tutto l'anno a Saviore dell'Adamello, Alpi Bresciane</p>
            <p>Scopri i sapori dei nostri prodotti di montagna.</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contatti" className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-info">
              <h3>L'Ampoma</h3>
              <p>🌿 Azienda Agricola di Montagna</p>
              <p>📍 Località Maé, Saviore dell'Adamello</p>
              <p>💼 P.IVA 04631340983</p>
              <p>🆔 C.F. CRCVNT83T53E734M</p>
              <p>📞 <a href="tel:+393921701259" style={{ color: 'white', textDecoration: 'none' }}>+39 392/1701259</a></p>
              <p>✉️ <a href="mailto:azienda.agricola@lampoma.it" style={{ color: 'white', textDecoration: 'none' }}>azienda.agricola@lampoma.it</a></p>
            </div>
            <div className="footer-social">
              <h4>Seguici</h4>
              <div className="social-links">
                <a href={"https://www.instagram.com/l_ampoma"} target={"_blank"} title={"Instagram"} className="social-link">
                  <FontAwesomeIcon icon={faInstagram} />
                  <span>@l_ampoma</span>
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024-2026 L'Ampoma. Tutti i diritti riservati.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
